// GameIconRenderer.tsx
import React from 'react';
import RenderImage from './RenderImage';
import SvgIcon from '@home/components/SvgIcon';

interface GameIconRendererProps {
  icon?: string;         // 自定义图标 URL
  defaultIcon: string;   // 默认 SVG 图标类型
}

/**
 * 游戏图标渲染组件
 * 
 * @param {Object} props - 组件属性
 * @param {string} [props.icon] - 图标URL，优先渲染
 * @param {string} [props.defaultIcon] - 默认图标类型，当icon不存在时渲染
 * @returns {React.ReactNode} 返回渲染的图标元素或null
 */
const GameIconRenderer: React.FC<GameIconRendererProps> = ({ icon, defaultIcon }) => {
  if (icon) {
    return <RenderImage src={icon} className="dba-may-ask-chart-segment-cascade-item-img" />;
  }

  if (defaultIcon) {
    return <SvgIcon type={defaultIcon} />;
  }

  return null;
};

export default GameIconRenderer;